
import { useCallback, useEffect, useState } from "react";
import { readJSON, writeJSON } from "../lib/safeStorage";

const KEY = "db_saved_searches_v1";

export interface SavedSearch {
  id: string;
  name: string;
  params: string; // serialized URL query (filters + map view), reuses Batch 1
  savedAt: number;
}

function makeId(): string {
  try {
    if (typeof crypto !== "undefined" && crypto.randomUUID)
      return crypto.randomUUID();
  } catch {
    /* fall through */
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

// Persisted named searches (current filters + map bounds serialized as a URL
// query string). Restoring one re-applies the exact filters + view.
export function useSavedSearches() {
  const [searches, setSearches] = useState<SavedSearch[]>(() =>
    readJSON<SavedSearch[]>(KEY, [])
  );

  useEffect(() => {
    writeJSON(KEY, searches);
  }, [searches]);

  const save = useCallback((name: string, params: string) => {
    const clean = name.trim();
    if (!clean) return;
    setSearches((prev) => [
      { id: makeId(), name: clean, params, savedAt: Date.now() },
      ...prev,
    ]);
  }, []);

  const remove = useCallback((id: string) => {
    setSearches((prev) => prev.filter((s) => s.id !== id));
  }, []);

  return { searches, save, remove, count: searches.length };
}
